import { Columns } from "@fullscript/aviary-web";
import type { ReactNode } from "react";

import { Spacer } from "@aviary";
import { Container } from "@aviary/layouts";

import * as styles from "./JourneyCheckoutLayout.styles";

interface Props {
  leftContent: ReactNode;
  rightContent: ReactNode;
}

const JourneyCheckoutLayout = ({ leftContent, rightContent }: Props) => {
  return (
    <Container>
      <Spacer type="section" />
      <Columns>
        <Columns.Column columnWidth={6} tabletWidth={12}>
          <div css={styles.leftColumn}>{leftContent}</div>
        </Columns.Column>
        <Columns.Column columnWidth={6} tabletWidth={12}>
          <div css={styles.rightColumn}>{rightContent}</div>
        </Columns.Column>
      </Columns>
      <Spacer type="section" />
    </Container>
  );
};

export { JourneyCheckoutLayout };
